// Génère les formats les plus courants d'une date
import moment from "moment";

export const setDateAAAAMMJJ = (str = '') : string  =>{
  try {
    return new Date(str).toLocaleDateString("fr-FR", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric"
    });
  } catch (e: any) {
    return str;
  }
}

export const remainDateUtil = (date2: string) => {
  try {
    let date1 = new Date();
    let [day, month, year] = date2.split('/').map(Number);
    let targetDate = new Date(year, month, day);
    let diff = new Date(targetDate.getTime() - date1.getTime());

    let years = diff.getUTCFullYear() - 1970;
    let months = diff.getUTCMonth();
    let days = diff.getUTCDate() - 1;

    return { jours: days, mois: months, annee: years };
  } catch (e:any) {
    return null
  }
}

export const joursRestantsUtil = (dateCible = '') => {
  if (!dateCible) {
    return null;
  }

  // Date actuelle
  const aujourdhui = new Date();
  aujourdhui.setHours(0, 0, 0, 0);

  // Parser la date cible (format JJ/MM/AAAA)
  dateCible = parseFormatDateIDProtect(dateCible);

  const [jour, mois, annee] = dateCible.split('/').map(Number);
  const cible = new Date(annee, mois - 1, jour);
  cible.setHours(0, 0, 0, 0);

  // Calculer la différence en millisecondes
  const differenceMs = cible.getTime() - aujourdhui.getTime();

  // Convertir en jours
  const jours = Math.ceil(differenceMs / (1000 * 60 * 60 * 24));

  // Messages personnalisés selon le résultat
  if (jours > 0) {
    return {
      jours,
      message: `Expire dans ${jours} jour${jours > 1 ? 's' : ''}`,
      estPassee: false,
      dateCible: `${jour}/${mois}/${annee}`,
      dateActuelle: aujourdhui.toLocaleDateString('fr-FR')
    };
  } else if (jours === 0) {
    return {
      jours: 0,
      message: `Expire aujourd'hui!`,
      estPassee: false,
      dateCible: `${jour}/${mois}/${annee}`,
      dateActuelle: aujourdhui.toLocaleDateString('fr-FR')
    };
  } else {
    return {
      jours: jours,
      message: `Expiré il y a ${Math.abs(jours)} jour${Math.abs(jours) > 1 ? 's' : ''}`,
      estPassee: true,
      dateCible: `${jour}/${mois}/${annee}`,
      dateActuelle: aujourdhui.toLocaleDateString('fr-FR')
    };
  }
}

export function convertStringToDate (dateStr = ''): Date | null {
  try {
    if (!dateStr) return null;

    // Essai direct avec Date
    const standardDate = new Date(dateStr);
    if (!isNaN(standardDate.getTime())) return standardDate;

    // Match formats DD/MM/YYYY, DD-MM-YYYY, DD.MM.YYYY avec ou sans zéro
    const frMatch = dateStr.match(/^(\d{1,2})[\/\-.](\d{1,2})[\/\-.](\d{4})$/);
    if (frMatch) {
      const [, day, month, year] = frMatch;
      const isoString = `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
      const parsed = new Date(isoString);
      return !isNaN(parsed.getTime()) ? parsed : null;
    }

    return null;
  } catch (e: any) {
    return null;
  }
}


// EN format : JJ/MM/AAAA
export function parseFormatDateIDProtect (dateStr = ''): string {
  if (!dateStr) return '';

  try {
    dateStr = dateStr.substring(0, 10);
  } catch (e: any) {
    return dateStr;
  }

  // 1. Format FR : JJ/MM/AAAA, JJ-MM-AAAA, JJ.MM.AAAA
  const frMatch = dateStr.match(/^(\d{1,2})[\/\-.](\d{1,2})[\/\-.](\d{4})$/);
  if (frMatch) {
    const [, day, month, year] = frMatch;
    return `${day.padStart(2, '0')}/${month.padStart(2, '0')}/${year}`;
  }

  // 2. Format US : MM/DD/YYYY ou MM-DD-YYYY
  const usMatch = dateStr.match(/^(\d{1,2})[\/\-](\d{1,2})[\/\-](\d{4})$/);
  if (usMatch) {
    const [, month, day, year] = usMatch;
    return `${day.padStart(2, '0')}/${month.padStart(2, '0')}/${year}`;
  }

  // 3. Format ISO : YYYY-MM-DD ou YYYY/MM/DD
  const isoMatch = dateStr.match(/^(\d{4})[\/\-](\d{1,2})[\/\-](\d{1,2})$/);
  if (isoMatch) {
    const [, year, month, day] = isoMatch;
    return `${day.padStart(2, '0')}/${month.padStart(2, '0')}/${year}`;
  }

  // Sinon, retourne la date telle quelle
  return dateStr;
}